module.exports = __webpack_public_path__ + "static/media/a90.72160fa2.jpg";